import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { ToastService } from '../services/toast.service';
import { languageSettings } from '../lenguajeDatatable';
import { VendedorModalComponent } from '../vendedor-modal/vendedor-modal.component';
import { Vendedor } from '../models/vendedor.model';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive-bs5';
import 'pdfmake/build/vfs_fonts.js';

@Component({
  selector: 'app-vendedor',
  templateUrl: './vendedor.component.html',
  styleUrls: ['./vendedor.component.css'],
})
export class VendedorComponent implements OnInit {
  @ViewChild(VendedorModalComponent)
  vendedorModalComponent!: VendedorModalComponent;
  vendedores: Vendedor[] = [];
  dataTable: any;

  constructor(
    private apiSrv: ApiService,
    private loadingSrv: LoadingService,
    private toastSrv: ToastService
  ) {}

  ngOnInit(): void {
    this.obtenerVendedores();
  }

  obtenerVendedores(): void {
    this.loadingSrv.setLoading(true);
    if (this.dataTable) {
      this.dataTable.destroy();
      this.dataTable = null;
    }
    this.apiSrv.obtenerVendedores().subscribe({
      next: (data: Vendedor[]) => {
        this.vendedores = data;
        setTimeout(() => {
          this.inicializarTablaVendedores();
          this.loadingSrv.setLoading(false);
        }, 0);
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al cargar los vendedores',
          'error'
        );
        this.loadingSrv.setLoading(false);
      },
    });
  }

  inicializarTablaVendedores(): void {
    if (this.dataTable) {
      this.dataTable.destroy();
    }

    const tableBody = this.vendedores.map((vendedor) => {
      return [
        vendedor.id,
        vendedor.nombre,
        vendedor.apellido,
        vendedor.canalVenta,
        vendedor.activo ? 'Activo' : 'Inactivo',
        `<button class="btn-editar btn btn-link p-0 d-flex align-items-center"
          data-id="${vendedor.id}"
          data-nombre="${vendedor.nombre}"
          data-apellido="${vendedor.apellido}"
          data-canalVenta="${vendedor.canalVenta}"
          data-activo="${vendedor.activo}">
          Editar <i class="fas fa-pencil-alt ms-1"></i>
        </button>`,
      ];
    });

    this.dataTable = $('#tablaVendedores').DataTable({
      data: tableBody,
      language: languageSettings,
      columns: [
        { title: 'ID', visible: false },
        { title: 'Nombre' },
        { title: 'Apellido' },
        { title: 'Canal de Venta' },
        { title: 'Estado' },
        { title: 'Acciones', orderable: false },
      ],
      responsive: true,
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          title: 'Vendedores - Ribera Salud',
          filename: 'Vendedores - Ribera Salud',
          exportOptions: {
            columns: ':not(:last-child)',
          },
        },
        {
          extend: 'excel',
          title: 'Vendedores - Ribera Salud',
          filename: 'Vendedores - Ribera Salud',
          exportOptions: {
            columns: ':not(:last-child)',
          },
        },
        {
          extend: 'pdf',
          title: 'Vendedores - Ribera Salud',
          filename: 'Vendedores - Ribera Salud',
          messageTop: 'Listado de vendedores registrados en el sistema',
          exportOptions: {
            columns: ':not(:last-child)',
          },
        },
      ],
    });

    $('#tablaVendedores tbody').on('click', 'button.btn-editar', (event) => {
      const button = $(event.currentTarget);
      const vendedor: Vendedor = {
        id: Number(button.attr('data-id')),
        nombre: String(button.attr('data-nombre')),
        apellido: String(button.attr('data-apellido')),
        canalVenta: String(button.attr('data-canalVenta')),
        activo: button.attr('data-activo') === 'true',
      };
      this.editarVendedor(vendedor);
    });
  }

  recargarTabla(): void {
    this.obtenerVendedores();
  }

  abrirModoCreacionVendedor(): void {
    this.eliminarModalBackdrop();
    this.vendedorModalComponent.abrirModoCreacionVendedor();
  }

  editarVendedor(vendedor: Vendedor): void {
    this.eliminarModalBackdrop();
    this.vendedorModalComponent.abrirModoEdicionVendedor(vendedor);
  }

  eliminarModalBackdrop(): void {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((backdrop) => {
      backdrop.parentNode?.removeChild(backdrop);
    });
  }

  handleVendedorGuardado(): void {
    this.recargarTabla();
  }

  handleVendedorActualizado(): void {
    this.recargarTabla();
  }
}
